import swal from "sweetalert2";

export class Utils {
  static alertWithErrorMessage(message: string) {
    swal("Error", message, "error");
  }

  static alertWithSuccessMessage(message: string) {
    swal("Success", message, "success");
  }

  static formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

}